"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INCREASE_VALUE = exports.DECREASE_VALUE = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _lodash = _interopRequireDefault(require("lodash"));

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DECREASE_VALUE = 'DECREASE_VALUE';
exports.DECREASE_VALUE = DECREASE_VALUE;
var INCREASE_VALUE = 'INCREASE_VALUE';
/*
 USAGE EXAMPLES:
 <Form.Field inline control={NumberPicker} name={MULTIPLY_INPUT + ".times"} onChange={this.triggerChange} label="Copies to create" defaultValue={1} min={1} max={999} placeholder="Repeat ..." />
 <Form.Field width="8" control={NumberPicker} compact label="compact buttons" placeholder="Enter a number" defaultValue={6} min={-41} max={45} step={1} />
 <Form.Field width="8" control={NumberPicker} circular label="circular buttons" placeholder="Enter a number" defaultValue={6} min={-41} max={45} step={1} />
 <Form.Field width="8" control={NumberPicker} basic label="basic buttons" placeholder="Enter a number" defaultValue={4} min={-40} max={40} step={2} />

*/

exports.INCREASE_VALUE = INCREASE_VALUE;

var NumberPicker = /*#__PURE__*/function (_React$Component) {
  _inherits(NumberPicker, _React$Component);

  var _super = _createSuper(NumberPicker);

  function NumberPicker() {
    var _this;

    _classCallCheck(this, NumberPicker);

    _this = _super.call(this);
    _this.style = {
      "default": {
        input: {
          borderRadius: '0px',
          textAlign: 'right'
        },
        buttonLeft: {
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
          margin: '0px'
        },
        buttonRight: {
          borderTopLeftRadius: '0px',
          borderBottomLeftRadius: '0px'
        }
      },
      circular: {
        input: {
          textAlign: 'right'
        },
        buttonLeft: {
          marginRight: '3.5px'
        },
        buttonRight: {
          marginLeft: '3.5px'
        }
      }
    };
    _this.handleAction = _this.handleAction.bind(_assertThisInitialized(_this));
    _this.validateInput = _this.validateInput.bind(_assertThisInitialized(_this));
    _this.state = {
      touched: false,
      buffer: {}
    };
    return _this;
  }

  _createClass(NumberPicker, [{
    key: "handleAction",
    value: function handleAction(event) {
      var actionFilter = event.currentTarget.name;
      var currentValue = event.currentTarget.value.replace(',', '.').replace(/\D/g, '');
      var setVal = _lodash["default"].isFinite(parseFloat(this.props.value)) ? parseFloat(this.props.value) : null;
      var stepSize = _lodash["default"].isFinite(parseFloat(this.props.step)) ? parseFloat(this.props.step) : 1;

      switch (actionFilter) {
        case DECREASE_VALUE:
          if (this.props.value - stepSize >= this.props.min) setVal -= stepSize;else setVal = this.props.min;
          break;

        case INCREASE_VALUE:
          if (setVal + stepSize <= this.props.max) setVal += stepSize;else setVal = this.props.max;
          break;

        default:
          var parsedVal = parseFloat(currentValue);
          if (currentValue === '-') this.state.buffer = '-';

          if (!(parsedVal > this.props.max || parsedVal < this.props.min)) {
            setVal = currentValue;
          }

          break;
      }

      var lastChar = "".concat(setVal).charAt(setVal.length - 1) || '';
      var returnValue = setVal;
      var precision = 1000;
      if (_lodash["default"].isFinite(parseFloat(setVal))) returnValue = Math.floor(parseFloat(setVal) * precision) / precision;
      if (setVal === '' || setVal === '-' || lastChar === '.' || lastChar === ',') returnValue = setVal;
      setTimeout(this.props.onChange, 1, {
        name: this.props.name,
        value: returnValue
      });
    }
  }, {
    key: "validateInput",
    value: function validateInput(event, v) {
      var actionFilter = event.target.name;
      var currentValue = event.target.value;
      var setVal = this.props.value;

      switch (actionFilter) {
        case this.props.name:
          var parsedVal = parseFloat(currentValue);
          setVal = _lodash["default"].isFinite(parsedVal) ? parsedVal : null;
          if (parsedVal > this.props.max) setVal = this.props.max;
          break;

        case DECREASE_VALUE:
        case INCREASE_VALUE:
        default:
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var style = this.props.circular ? this.style.circular : this.style["default"];
      var display = {
        circular: this.props.circular,
        basic: this.props.basic,
        compact: this.props.compact
      };
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        className: this.props.classname_outer_input
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, _extends({}, display, {
        type: "button",
        icon: "minus",
        onClick: this.handleAction,
        name: DECREASE_VALUE,
        style: style.buttonLeft,
        disabled: this.props.value <= this.props.min,
        className: this.props.classname_button_minus
      })), ' ', /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        name: this.props.name,
        id: this.props.id,
        min: this.props.min,
        max: this.props.max,
        step: this.props.step,
        className: this.props.classname_inner_input,
        maxLength: this.props.maxLength,
        placeholder: this.props.placeholder,
        required: this.props.required,
        defaultValue: this.props.defaultValue,
        value: this.props.value,
        onChange: this.handleAction,
        onBlur: this.validateInput,
        style: style.input
      }), ' ', /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, _extends({}, display, {
        type: "button",
        icon: "plus",
        onClick: this.handleAction,
        name: INCREASE_VALUE,
        style: style.buttonRight,
        disabled: this.props.value >= this.props.max,
        className: this.props.classname_button_plus
      })), ' ');
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        placeholder: 'Enter a number',
        id: '',

        /*
               Limiting min, max value to 1e10 to prevent javascript to switch into scientific notation
               */
        min: 1e10 * -1,
        max: 1e10,
        maxLength: 10,
        step: 1,
        required: false,
        basic: false,
        circular: false,
        compact: false,
        classname_button_minus: 'number_picker_button_minus',
        classname_button_plus: 'number_picker_button_plus',
        classname_outer_input: 'number_picker',
        classname_inner_input: 'number_picker_input'
      };
    }
  }]);

  return NumberPicker;
}(_react["default"].Component);

NumberPicker.propTypes = {
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string,
  value: _propTypes["default"].any,
  defaultValue: _propTypes["default"].any,
  onChange: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].string,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  step: _propTypes["default"].number,
  maxLength: _propTypes["default"].number,
  required: _propTypes["default"].bool,
  basic: _propTypes["default"].bool,
  circular: _propTypes["default"].bool,
  compact: _propTypes["default"].bool
};
var _default = NumberPicker;
exports["default"] = _default;